<template>
  <div class="template-padding">
    <div class="row">
      <div class="col col-sm-12">
        <h4 class="font-weight-bolder">
          ADD NEW TRAINING CENTER
        </h4>
      </div>
    </div>
    <hr style="border-color: black">

    <form
      class="card"
      @submit="addTrainingCenter"
    >
      <div class="card-body row">
        <div class="col col-sm-6">
          <div
            class="form-group form-row"
            :class="{'has-error': errorTrainingCenterCreate.code !== ''}"
          >
            <label
              class="col col-sm-2 col-form-label font-weight-bolder text-right"
              for="code"
            >CODE:</label>
            <div class="col col-sm-10">
              <input
                type="text"
                name="code"
                id="code"
                placeholder="TRAINING CENTER CODE"
                class="form-control form-control-xs"
                v-model="newTrainingCenter.code"
                @input="capitalize($event, newTrainingCenter, 'code')"
              >
              <span
                class="help-block"
                v-if="errorTrainingCenterCreate.code !== ''"
              >
                <small><strong>{{ errorTrainingCenterCreate.code }}</strong></small>
              </span>
            </div>
          </div>

          <div
            class="form-group form-row"
            :class="{'has-error': errorTrainingCenterCreate.name !== ''}"
          >
            <label
              class="col col-sm-2 col-form-label font-weight-bolder text-right"
              for="name"
            >NAME:</label>
            <div class="col col-sm-10">
              <input
                type="text"
                name="name"
                id="name"
                placeholder="TRAINING CENTER NAME"
                class="form-control form-control-xs"
                v-model="newTrainingCenter.name"
                @input="capitalize($event, newTrainingCenter, 'name')"
              >
              <span
                class="help-block"
                v-if="errorTrainingCenterCreate.name !== ''"
              >
                <small><strong>{{ errorTrainingCenterCreate.name }}</strong></small>
              </span>
            </div>
          </div>

          <div
            class="form-group form-row"
            :class="{'has-error': errorTrainingCenterCreate.email !== ''}"
          >
            <label
              class="col col-sm-2 col-form-label font-weight-bolder text-right"
              for="email"
            >EMAIL:</label>
            <div class="col col-sm-10">
              <input
                type="email"
                name="name"
                id="email"
                placeholder="TRAINING CENTER EMAIL"
                class="form-control form-control-xs"
                v-model="newTrainingCenter.email"
              >
              <span
                class="help-block"
                v-if="errorTrainingCenterCreate.email !== ''"
              >
                <small><strong>{{ errorTrainingCenterCreate.email }}</strong></small>
              </span>
            </div>
          </div>

          <div class="form-group form-row">
            <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
              STATUS:
            </div>
            <div class="col col-sm-1">
              <input
                type="checkbox"
                name="status"
                id="status"
                class="form-control form-control-xs"
                v-model="newTrainingCenter.status"
              >
            </div>
            <label class="col-sm-3 col-form-label font-weight-bolder">
              {{ newTrainingCenter.status ? 'ACTIVE':'INACTIVE' }}
            </label>
          </div>
        </div> <!-- <div class="col col-sm-6"> left col-->

        <div class="col col-sm-6">
          <div
            class="form-group form-row"
            :class="{'has-error': errorTrainingCenterCreate.contact_number !== ''}"
          >
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="contact_number"
            >CONTACT NUMBER:</label>
            <div class="col col-sm-9">
              <input
                type="text"
                name="contact_number"
                id="contact_number"
                placeholder="TRAINING CENTER CONTACT NUMBER"
                class="form-control form-control-xs"
                v-model="newTrainingCenter.contact_number"
                @input="capitalize($event, newTrainingCenter, 'contact_number')"
              >
              <span
                class="help-block"
                v-if="errorTrainingCenterCreate.contact_number !== ''"
              >
                <small><strong>{{ errorTrainingCenterCreate.contact_number }}</strong></small>
              </span>
            </div>
          </div>

          <div
            class="form-group form-row"
            :class="{'has-error': errorTrainingCenterCreate.contact_person !== ''}"
          >
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="contact_person"
            >CONTACT PERSON:</label>
            <div class="col col-sm-9">
              <input
                type="text"
                name="contact_person"
                id="contact_person"
                placeholder="TRAINING CENTER CONTACT PERSON"
                class="form-control form-control-xs"
                v-model="newTrainingCenter.contact_person"
                @input="capitalize($event, newTrainingCenter, 'contact_person')"
              >
              <span
                class="help-block"
                v-if="errorTrainingCenterCreate.contact_person !== ''"
              >
                <small><strong>{{ errorTrainingCenterCreate.contact_person }}</strong></small>
              </span>
            </div>
          </div>

          <div
            class="form-group form-row"
            :class="{'has-error': errorTrainingCenterCreate.faxno !== ''}"
          >
            <label
              class="col col-sm-3 col-form-label font-weight-bolder text-right"
              for="faxno"
            >FAX NUMBER:</label>
            <div class="col col-sm-9">
              <input
                type="text"
                name="faxno"
                id="faxno"
                placeholder="TRAINING CENTER FAX NUMBER"
                class="form-control form-control-xs"
                v-model="newTrainingCenter.faxno"
                @input="capitalize($event, newTrainingCenter, 'faxno')"
              >
              <span
                class="help-block"
                v-if="errorTrainingCenterCreate.faxno !== ''"
              >
                <small><strong>{{ errorTrainingCenterCreate.faxno }}</strong></small>
              </span>
            </div>
          </div>
        </div> <!-- <div class="col col-sm-6"> right col-->

        <div class="col col-sm-12">
          <div
            class="form-group"
            :class="{'has-error': errorTrainingCenterCreate.address !== ''}"
          >
            <label
              class="font-weight-bolder"
              for="address"
            >ADDRESS: </label>
            <textarea
              name="address"
              id="address"
              rows="4"
              class="form-control form-control-xs"
              placeholder="TRAINING CENTER ADDRESS"
              v-model="newTrainingCenter.address"
              @input="capitalize($event, newTrainingCenter, 'address')"
            />
            <span
              class="help-block"
              v-if="errorTrainingCenterCreate.address !== ''"
            >
              <small><strong>{{ errorTrainingCenterCreate.address }}</strong></small>
            </span>
          </div>
        </div>
      </div> <!-- <div class="card-body row">-->

      <div class="card-footer text-right">
        <button
          type="submit"
          class="btn btn-sm btn-outline-primary font-weight-bolder mr-3"
        >
          <span><i class="fas fa-save" /></span>
          SAVE
        </button>
        <a
          href="#"
          class="btn btn-sm btn-outline-secondary font-weight-bolder"
          @click="goBack"
        >
          <span><i class="fas fa-backward" /></span>GO BACK
        </a>
      </div>
    </form>
  </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { formMixins } from "../../../mixins/formMixins";
    export default {
        mixins: [formMixins],
        name: 'CreateTrainingCenter',
        methods: {
            ...mapActions([ 'createTrainingCenter' ]),
            async addTrainingCenter(e) {
                e.preventDefault();
                if(await this.confirmCreateAlert('Are you sure you want to add this training center?')) {
                    let id = await this.createTrainingCenter();
                    if(id) {
                        this.successAlert('New Training Center Successfully Created', 'CREATE');
                        this.$router.push(`/trainingCenter/${id}`);
                    } else {
                        this.errorAlert(this.generateErrorMessage(this.errorTrainingProviderCreate), 'ADD RECORD');
                    }
                }
            }
        },
        computed: {
            ...mapGetters([ 'newTrainingCenter', 'errorTrainingCenterCreate' ])

        }
    };
</script>

<style scoped>

</style>
